module.exports = __webpack_public_path__ + "img/rem.d6350a79.jpg";